import { render, staticRenderFns } from "./SectionKuko.vue?vue&type=template&id=341d538f&"
import script from "./SectionKuko.vue?vue&type=script&lang=js&"
export * from "./SectionKuko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports